
import { AuditInstructionSearchRequestModel } from '@alcon-db-models/AuditInstructionSearchRequestModel';
import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { DataBindingDirective, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { FilterDescriptor } from '@progress/kendo-data-query';
import { AuditInstructionSearchService } from '@services/audit-instruction-search.service';
import { UserPreferencesService } from '@services/user-preferences.service';
import { Subscription } from 'rxjs';
import { JsonUtilities } from '../shared/json-utilities';
import { SelectSearchBindingBaseDirective } from './select-search-binding.base.directive';
import { UserPreferenceEnabledDataBindingDirective } from './user-preference-enabled-data-binding.directive';

@Directive({
  selector: '[auditInstructionSearchBindingDirective]'
})
export class AuditInstructionSearchBindingDirective  extends UserPreferenceEnabledDataBindingDirective implements OnInit, OnDestroy {

  @Input() preferenceKey: string = "AuditInstructionSearch";

  private serviceSubscription?: Subscription;

  constructor(
    grid: GridComponent,
    userPreferencesService: UserPreferencesService,
    changeDetectorRef: ChangeDetectorRef,
    public auditInstructionSearchService: AuditInstructionSearchService
    ) {
    super(grid, userPreferencesService, changeDetectorRef);
  }

  public ngOnInit(): void {

    this.auditInstructionSearchService.next([] as any as GridDataResult);

    this.serviceSubscription = this.auditInstructionSearchService.subscribe((result) => {
      result = JsonUtilities.convertDatesAndCopy(result);
      this.grid.loading = false;
      this.grid.data = result;
      this.notifyDataChange();
      this.grid.loading = false;
    });

    super.ngOnInit();
  }

  public ngOnDestroy(): void {
    if (this.serviceSubscription) {
        this.serviceSubscription.unsubscribe();
    }
    super.ngOnDestroy();
  }

  public rebind(): void {
    this.grid.loading = true;
    this.auditInstructionSearchService.query(this.getSearchRequest());
  }

  public getSearchRequest(doIgnorePagination: boolean = false): AuditInstructionSearchRequestModel {

    const request = <AuditInstructionSearchRequestModel>{};
    const filters: FilterDescriptor[] = this.state.filter?.filters as FilterDescriptor[];
    // TODO: all directives should enumerate filters (like below) instead of hard coding them.  Create base search directive?
    filters?.forEach(x => { if (typeof(x.field) === 'string') { (request as any)[x.field] = x.value; }});

    return ({
      ...request,
      personID: null,
      take: doIgnorePagination ? null : this.state.take,
      skip: doIgnorePagination ? 0 : this.state.skip,
      sortColumn: this.state.sort?.[0]?.dir ? this.state.sort?.[0]?.field : null,
      sortAscending: this.state.sort?.[0]?.dir ? this.state.sort[0].dir != 'desc' : null,
    });
  }
}

